<template>
  <div>
    <TopNavbar></TopNavbar>
    <router-view></router-view>
  </div>
</template>

<script>
  import TopNavbar from "./TopNavbar.vue";

  export default {
    name: "SignedInView",
    components: {
      TopNavbar,
    },
    created() {
      this.$store.dispatch("fetchIsAdmin");
    },
  };
</script>
